export default __webpack_public_path__ + "static/media/Group 1108.600feb4d.svg";